import { AjaxError } from "rxjs/ajax";

export function panic(err: any) {
    let showErr = err;
    if (err instanceof AjaxError) {
        showErr = err.response?.error ?? "Erreur inconnue.";
    } else if (err instanceof Error) {
        showErr = err.message;
    }
    alert(showErr);
}